import { get, type Path } from 'react-hook-form';

export function uniqBy<T, U extends Path<T>>(array: T[], path: U): T[] {
  const keySet = new Set<string>();
  return array.filter((item) => {
    const key = get(item, path);
    if (keySet.has(key)) {
      return false;
    }
    keySet.add(key);
    return true;
  });
}
